export * from './datetime';
export * from './puzzles';
export * from './coloringGrids';
export * from './artists';
export * from './countries';
export * from './emails';
export * from './gotiva';

// Image resolutions
export const PuzzleIconSize = 256;
export const PuzzleImageSize = 1024;
export const Puzzle2kImageSize = 2048;

// Quality settings
export const JPEGQualityHigh = 0.95;
